module.exports = __webpack_public_path__ + "static/img/装饰15.c93acde.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/penholder/imgs/装饰15.svg
// module id = 6T/I
// module chunks = 2